import { createContext, useContext } from 'react';

interface ToggleButtonGroupContextValue<T = unknown> {
  value: T;
  exclusive: boolean;
  onChange: (value: T) => void;
}

export const ToggleButtonGroupContext =
  createContext<ToggleButtonGroupContextValue | null>(null);

export const useToggleButtonGroup = () => {
  const context = useContext(ToggleButtonGroupContext);
  if (!context) {
    throw new Error(
      'useToggleButtonGroup must be used within a ToggleButtonGroup'
    );
  }
  return context;
};
